import { IServiceApproval } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { BaseStateExtension } from '@common/state/state-extension';
import { ServiceApprovalModelName } from 'src/app/shared/models/model-names';

export const SERVICES_APPROVAL_TAB_STATE_NAME = 'ServicesApprovalTabState';

@Injectable({ providedIn: 'root' })
export class ServiceApprovalStateExtension extends BaseStateExtension<IServiceApproval> {
  public name = ServiceApprovalModelName;
  public patientIdToObserve: string | null = null;

  public async canBeStored(item: IServiceApproval): Promise<boolean> {
    if (!item || item.archived) {
      return false;
    }

    return item.patientId === this.patientIdToObserve;
  }

  protected async afterCreateInternal(item: IServiceApproval) {
    await this.stateRegistry.createBySync(ServiceApprovalModelName, SERVICES_APPROVAL_TAB_STATE_NAME, item);
  }

  protected async afterUpdateInternal(item: IServiceApproval) {
    await this.stateRegistry.updateBySync(ServiceApprovalModelName, SERVICES_APPROVAL_TAB_STATE_NAME, [item]);
  }

  protected async removeFromState(item: IServiceApproval) {
    await this.stateRegistry.removeBySync(ServiceApprovalModelName, SERVICES_APPROVAL_TAB_STATE_NAME, [item]);
  }
}
